import { INewbuildingBuilder, ISeller } from '../../../types/newbuilding/builder';

interface IOpen<T> {
  seller: T;
  opened: { realtyUserId: number; phone: string }[];
}

export function markAsOpen<T extends INewbuildingBuilder | ISeller>({ seller, opened }: IOpen<T>): T {
  const sellerOpened = opened.find(item => item.realtyUserId === seller.realtyUserId);

  if (sellerOpened) {
    return {
      ...seller,
      isOpen: true,
      dynamicPhone: sellerOpened.phone,
    };
  }

  return seller;
}
